import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '../../atoms/icon/icon.component';
import { IconSize } from '../../../enums/icon.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header-item',
  imports: [CommonModule, RouterModule, IconComponent, TranslateModule],
  templateUrl: './header-item.component.html',
  styleUrl: './header-item.component.scss'
})
export class HeaderItemComponent {
  @Input() icon!: string;
  @Input() label!: string;
  @Input() link?: string; // optional
  @Output() action = new EventEmitter<void>();

  public IconSize: typeof IconSize = IconSize;

}
